const ENDPOINTS = {
  RECORDED_CONTACTS: "/contact-management/recorded-contacts",
  THIRD_PARTY_CONTACTS: "/contact-management/third-party-contacts",
  USERS: {
    USERS: "/user-management/users",
    MARK_TRAINING_SEEN: "/user-management/users/mark-training-video-seen",
    FETCH_TRAINING_VIDEOS: "/user-management/users/training/list",
    MARK_TRAINING_VIDEO_COMPLETED: "/user-management/users/training/complete",
  },
  RECORDED_CALLS: {
    GET_RECORDED_CALLS: "/recordings/recorded-calls",
    GET_RECORDING_PLAYBACK: "/recordings/recorded-calls",
    GET_RECORDING_DOWNLOAD: "/recordings/recorded-calls",
    RETAIN_RECORDED_CALL: "/recordings/recorded-calls",
    RELEASE_RECORDED_CALL: "/recordings/recorded-calls",
  },
  AUTH: {
    LOGIN: "/user-management/auth/login",
    LOGOUT: "/user-management/auth/logout",
    VERIFY: "/user-management/auth/verify-user",
    FORGOT_PASSWORD: "/user-management/auth/forgot-password",
    RESET_PASSWORD: "/user-management/auth/reset-password",
    REFRESH_TOKEN: "/user-management/auth/refresh-token",
  },
  PLAYLIST: {
    GET_PLAYLISTS: "/recordings/playlists",
    CREATE_PLAYLIST: "/recordings/playlists",
    GET_PLAYLIST_CALLS: "/recordings/playlists",
    MARK_AS_REVIEWED: "/recordings/playlists",
    GET_PLAYLIST_CALL_AUDIO: "/recordings/playlists",
    REVIEW_FORMS: "/recordings/playlists",
  },
  RECORDED_CONTACTS_INSIGHTS: "/insights/recorded-contacts",
  REPORTS: "/insights/reports",
};

export default ENDPOINTS;
